import axios from 'axios'
import { ENVIRONMENT } from './environment.config'
import { attachNavigationSource } from './navigation-source'

export const SERVER_URL = ENVIRONMENT.SERVER_URL

export const apiClient = axios.create({
  baseURL: SERVER_URL,
  headers: { 'Content-Type': 'application/json; charset=utf-8' },
})

// Both clients: legacy axios.helpers.ts still uses bare axios
axios.interceptors.request.use(attachNavigationSource)
apiClient.interceptors.request.use(attachNavigationSource)
